import { z } from "zod";

import { LIMITS } from "../constants.js";
import { isoUtcSchema, labelIdSchema, messageIdSchema, pageInfoSchema } from "./common.js";

export const labelColorSchema = z
  .string()
  .regex(/^#[0-9a-fA-F]{6}$/, "Colors are six-digit hex, e.g. #1a73e8");

export const labelSchema = z.object({
  id: labelIdSchema,
  name: z.string().min(1).max(LIMITS.maxLabelNameLength),
  color: labelColorSchema,
  kind: z.enum(["user", "system"]),
  messageCount: z.number().int().nonnegative().optional(),
  createdAt: isoUtcSchema,
});
export type Label = z.infer<typeof labelSchema>;

export const listLabelsResponseSchema = z.object({
  labels: z.array(labelSchema),
  pageInfo: pageInfoSchema,
});
export type ListLabelsResponse = z.infer<typeof listLabelsResponseSchema>;

export const createLabelRequestSchema = z.object({
  name: z.string().min(1).max(LIMITS.maxLabelNameLength),
  color: labelColorSchema.default("#1a73e8"),
});
export type CreateLabelRequest = z.infer<typeof createLabelRequestSchema>;

export const updateLabelRequestSchema = z.object({
  name: z.string().min(1).max(LIMITS.maxLabelNameLength).optional(),
  color: labelColorSchema.optional(),
});
export type UpdateLabelRequest = z.infer<typeof updateLabelRequestSchema>;

export const setMessageLabelRequestSchema = z.object({
  messageIds: z.array(messageIdSchema).min(1).max(1000),
  labelId: labelIdSchema,
});
export type SetMessageLabelRequest = z.infer<typeof setMessageLabelRequestSchema>;
